export default class Airport {
  id = '';
  name = '';

  constructor({ id = '', name = '' } = {}) {
    this.id = id;
    this.name = name;
  }

  clone = () => {
    return new Airport({
      id: this.id,
      name: this.name,
    });
  };
}
